import api from "../api/axios";

export const getEmployeesSalary = async (company_id, month) => {
  try {
    const response = await api.get(
      `companies/${company_id}/departments/employees/salaries?month=${month}`
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const getCompanySalaryConfig = async (company_id) => {
  try {
    const response = await api.get(`salary-config/${company_id}`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const getSalaryData = (salaryData, config) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(salaryData)) {
      return reject(new Error("Invalid salary Data: Expected an array"));
    }

    const {
      payroll_release_date,
      salary_slip_visibility_days,
      payroll_release_month,
    } = config || {};

    if (
      !payroll_release_date ||
      salary_slip_visibility_days === null ||
      !payroll_release_month
    ) {
      return reject(new Error("Invalid config: Missing required fields"));
    }

    const currentDate = new Date();

    const filteredData = salaryData.filter(({ month }) => {
      const salaryMonth = new Date(`${month}-01`);
      const releaseDate = new Date(salaryMonth);

      releaseDate.setDate(payroll_release_date);

      if (payroll_release_month === "next_month") {
        releaseDate.setMonth(releaseDate.getMonth() + 1);
      }

      const visibleDate = new Date(releaseDate);
      visibleDate.setDate(releaseDate.getDate() + salary_slip_visibility_days);

      return currentDate >= visibleDate;
    });

    resolve(filteredData);
  });
};

export const sendSalaryAcknowledgment = async (data) => {
  try {
    const response = await api.put(`salary-credited-acknowledgment`, data);
    if (response.data.success) {
      return response.data.message;
    }
  } catch (error) {
    throw error;
  }
};
